import UsuariosTemplate from "../components/templates/UsuariosTemplate"

const Usuarios = () => {
    return <UsuariosTemplate/>;
};

export default Usuarios;